import React from "react"
import { store } from "../../../../stores/Store"
import { EnquiryInitiateDto } from "../../../../models/Enquiry"
import EnquirySubjectFormSection from "./EnquirySubjectFormSection"
import EnquiryAssessmentFormSection from "./EnquiryAssessmentFormSection"
import EnquiryDataSourcesFormSection from "./EnquiryDataSourcesFormSection"
import Ajax from "../../../../Ajax"
import { Alert } from "../../../.."
import EnquiryJobFormSection from "./EnquiryJobForm"
import { action } from "mobx"


var jobRelatedStatuses = ["UKCS_SW_J", "UKLLR_SW_P", "UKLLR_UKX_P", "UKLLR_GTR_P", "UKLLR_SNR_P"]


export default function EnquiryCreateForm ({caseUid}) {

    const [loading, setLoading] = React.useState(false)
    const [enquiry, setEnquiry] = React.useState<EnquiryInitiateDto>(null)
    const [questionnaireUidArray, setQuestionnaireUidArray] = React.useState<string[]>(null)
    const [subjectData, setSubjectData] = React.useState(null)
    const [subject, setSubject] = React.useState(null)
    const [job, setJob] = React.useState(null)

    const includeJobForm = !!enquiry?.statuses.find(status => status.selected && jobRelatedStatuses.includes(status.code))

    const onSubmit = async () => {

        setLoading(true)

        var enquiryInitiateDto = {
            ...enquiry,
            caseUid: caseUid,
            questionnaireUidList: questionnaireUidArray,
            subjectUid: subject.subjectUid,
            subjectInfo: subject.subjectInfo,
            jobInfo: job?.jobInfo,
            jobUid: job?.jobUid
        }

        await Ajax.Enquiry.Initiate(enquiryInitiateDto).then((response) => {
            store.NodeStore.refreshFolderNode()
            store.AlertStore.Close()
        }).catch(response => {
            Alert({color: "error", message: response.data?.detail ? response.data.detail : "Failed to create enquiry"})
        })

        setLoading(false)
    }

    React.useEffect(() => {
        if ((includeJobForm && job) || !includeJobForm && subject) {
            onSubmit()
        }
    }, [job, subject])

    return (
        <div className={loading ? "form disabled" : "form"} style={{width: "80vw", maxWidth: !enquiry || !questionnaireUidArray ? "700px" : "400px"}}>
            <EnquiryAssessmentFormSection 
                hidden={!!enquiry}
                caseUid={caseUid}
                onCancel={() => store.AlertStore.Close()} 
                onSubmit={(data) => setEnquiry(data)} />

            <EnquiryDataSourcesFormSection
                enquiry={enquiry}
                hidden={!enquiry || !!questionnaireUidArray}
                onCancel={() => setEnquiry(null)} 
                onSubmit={async (data) => {
                    setLoading(true)
                    await Ajax.Enquiry.GetNewSubjectDetails(data).then((response) => {
                        setSubjectData(response.data)
                    })
                    setQuestionnaireUidArray(data)
                    setLoading(false)
                }} />
        
            <EnquirySubjectFormSection 
                hidden={!enquiry || !subjectData || !!subject}
                subjectData={subjectData}
                onCancel={() => {
                    setQuestionnaireUidArray(null)
                    setSubjectData(null)
                }} 
                onSubmit={async (data) => setSubject(data)} />

            <EnquiryJobFormSection
                hidden={!includeJobForm || !enquiry || !questionnaireUidArray || !subject}
                caseUid={caseUid}
                subjectData={subjectData}
                onCancel={() => setSubject(null)} 
                onSubmit={async (data) => setJob(data)} />
        </div>
    )
}


